var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 0.833374V2.50004H12.4993V0.833374H14.166V2.50004H17.4993C17.9596 2.50004 18.3327 2.87314 18.3327 3.33337V16.6667C18.3327 17.127 17.9596 17.5 17.4993 17.5H2.49935C2.03912 17.5 1.66602 17.127 1.66602 16.6667V3.33337C1.66602 2.87314 2.03912 2.50004 2.49935 2.50004H5.83268V0.833374H7.49935ZM16.666 9.16671H3.33268V15.8334H16.666V9.16671ZM9.16602 10.8334V14.1667H4.99935V10.8334H9.16602ZM5.83268 4.16671H3.33268V7.50004H16.666V4.16671H14.166V5.83337H12.4993V4.16671H7.49935V5.83337H5.83268V4.16671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar2.d0b5e0efa4f40ab5d748f724f32e1aef.svg";
export { ForwardRef as ReactComponent };